import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { SnackbarProvider } from "notistack";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DataProvider } from "./context/DataProvider";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";
//added for error handling
import { HttpErrorProvider } from './context/HttpErrorContext';
import HttpErrorHandler from './components/HttpErrorHandler';
import { ErrorBoundary } from './components/ErrorBoundary';

import ScrollToTop from "./utils/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";
import "./static/css/App.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <ErrorBoundary>
      <HttpErrorProvider>
        <BrowserRouter>
        <HttpErrorHandler>
          <DataProvider>
             <ScrollToTop />   {/* ← fires on every route change */}
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </DataProvider>
          </HttpErrorHandler>
        </BrowserRouter>
      </HttpErrorProvider>
      </ErrorBoundary>
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>
);
